import list from 'tabulator-tables/src/js/modules/Edit/defaults/editors/list.js';

function createDiv(styles = {}, classes = []) {
  const div = document.createElement('div');
  Object.entries(styles).forEach(([style, value]) => {
    div.style[style] = value;
  });

  classes.forEach(cls => div.classList.add(cls));

  return div;
}

function getCumulativeProp(elem, prop) {
  let _elem = elem;
  let running = 0;
  do {
    if (!isNaN(elem[prop])) {
      running += _elem[prop];
    }

    _elem = _elem.offsetParent
  } while (_elem);

  return running;
}

function getOffsetLeft(elem) {
  return getCumulativeProp(elem, 'offsetLeft');
}

function getOffsetTop(elem) {
  return getCumulativeProp(elem, 'offsetTop');
}

function beatingHeart(cell, onRendered, success, cancel, editorParams) {
  const outer = createDiv();
  const { hearts } = editorParams;

  const current = cell.getTable().getHeaderFilterValue(cell.getField()) || {};

  const { department = '', range = '' } = current;

  const container = createDiv({
    display: 'flex',
    alignItems: 'center',
    gap: '1em',
  })

  let selectedDepartment = department;

  const listCell = {
    ...cell,
    getValue() {
      return department;
    }
  };

  const departmentsSelector = list.call(this, listCell, onRendered, onSelectDepartment, onCancelDepartment, {
    ...editorParams,
    defaultValue: department,
  });

  const selectedHeart = createDiv({
    height: '20px',
    width: '100px',
    display: selectedDepartment ? 'block' : 'none',
    backgroundColor: '#575e5f',
    border: '1px solid #fff',
    borderRadius: '.25rem',
  });

  selectedHeart.innerHTML = '<i class="fa fa-heart"></i>'

  setRange(selectedDepartment, range, false);

  const heartList = createDiv({ display: 'none' }, ['tabulator-popup-container']);
  document.body.appendChild(heartList);

  function onSelectDepartment(department) {
    selectedDepartment = department;
    selectedHeart.style.display = 'block';
    setDepartment(department)
  }

  function setDepartment(department, post = true) {
    success({ department });

    selectedHeart.style.display = department ? 'block' : 'none';
    setRange(department, '', post)
  }

  function setRange(department, range, post = true) {
    selectedHeart.style.color = hearts[range] || '#fff';

    selectedHeart.style.display = department ? 'block' : 'none';

    if (post) {
      success({
        department,
        range,
      })
    }
  }

  function onCancelDepartment() {
    selectedDepartment = false;
    selectedHeart.style.display = 'none';
    cancel();
  }

  selectedHeart.addEventListener('click', () => {
    if (selectedDepartment) {
      heartList.style.top = String(getOffsetTop(selectedHeart) + selectedHeart.offsetHeight) + 'px';
      heartList.style.left = String(getOffsetLeft(selectedHeart)) + 'px'
      heartList.style.display = heartList.style.display === 'none' ? 'block' : 'none';
    }
  });

  const entries = Object.entries(hearts);
  entries.sort(([a], [b]) => {
    const aR = parseFloat(a);
    const bR = parseFloat(b);
    if (aR < bR) {
      return -1;
    }

    if (aR > bR) {
      return 1;
    }

    return 0;
  });

  entries.map(([range, color]) => {
    const div = createDiv();

    const button = document.createElement('button');
    button.type = 'button';
    button.classList.add('btn', 'btn-lg');
    button.style.color = color;
    button.innerHTML = '<i class="fa fa-heart"></i>';
    button.dataset.range = range;

    button.addEventListener('click', () => {
      if (selectedDepartment) {
        heartList.style.display = 'none';
        setRange(selectedDepartment, range)
      }
    })

    div.appendChild(button);

    return div;
  }).forEach(el => heartList.appendChild(el));
  
  const clear = document.createElement('button');
  clear.type = 'button'
  clear.classList.add('btn', 'btn-sm');
  clear.innerHTML = '<i class="fa fa-times"></i>'
  clear.addEventListener('click', function () {
    const event = new Event('change');
    selectedDepartment = '';
    departmentsSelector.value = '';
    departmentsSelector.dispatchEvent(event);
    setRange(selectedDepartment, '');
  });

  container.appendChild(departmentsSelector);
  container.appendChild(selectedHeart);
  container.appendChild(clear);

  outer.appendChild(container);

  return outer;
}

export default beatingHeart;